export default __webpack_public_path__ + "static/tpci_logo-07ff252c9f564da9511893e9d1fcc526.svg";